import { render, staticRenderFns } from "./MenuBreadcrumb.vue?vue&type=template&id=19965618&scoped=true&"
import script from "./MenuBreadcrumb.vue?vue&type=script&lang=js&"
export * from "./MenuBreadcrumb.vue?vue&type=script&lang=js&"
import style0 from "./MenuBreadcrumb.vue?vue&type=style&index=0&id=19965618&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19965618",
  null
  
)

export default component.exports